import React from "react";

const STEPS = [
  {
    n: "01",
    title: "Visualize",
    body: "Start with our live configurator or share your inspirations. We finalize a moodboard and material palette together.",
  },
  {
    n: "02",
    title: "Measure & Design",
    body: "A senior designer visits your home, measures every wall, and builds 3D walkthroughs of every room.",
  },
  {
    n: "03",
    title: "Approve & Plan",
    body: "We lock the BoQ, finishes, hardware brands and a day-by-day Gantt before any work begins.",
  },
  {
    n: "04",
    title: "Manufacture",
    body: "Everything is precision-built in our climate-controlled Hubballi factory — never on-site improvisation.",
  },
  {
    n: "05",
    title: "Install & Handover",
    body: "Site installation in 7–10 days with a dedicated project manager. Final styling and a complete handover.",
  },
];

const Process = () => (
  <section
    id="process"
    className="relative bg-[#EAE6DF] text-[#0A0A0A]"
    data-testid="process-section"
  >
    <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-12 md:py-32">
      <div className="grid items-end gap-6 md:grid-cols-12">
        <div className="md:col-span-7">
          <span className="text-[10px] uppercase tracking-[0.32em] text-[#0A0A0A]/55">05 · Process</span>
          <h2 className="mt-4 font-[Cormorant_Garamond] text-4xl font-light leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
            Five steps,<br />
            <span className="italic text-[#B8996F]">zero</span> surprises.
          </h2>
        </div>
        <div className="md:col-span-5">
          <p className="font-[Outfit] text-base leading-relaxed text-[#0A0A0A]/70">
            A studio process designed around predictability — fixed scope, fixed timeline and fixed price before
            we cut a single board.
          </p>
        </div>
      </div>

      <div className="mt-14 border-t border-[#0A0A0A]/15">
        {STEPS.map((s) => (
          <div
            key={s.n}
            data-testid={`process-step-${s.n}`}
            className="grid grid-cols-1 gap-4 border-b border-[#0A0A0A]/15 py-8 transition-colors duration-300 hover:bg-[#F7F5F0] md:grid-cols-12 md:items-baseline md:py-10"
          >
            <div className="md:col-span-2">
              <div className="font-[Cormorant_Garamond] text-5xl font-light text-[#B8996F]">{s.n}</div>
            </div>
            <div className="md:col-span-4">
              <div className="font-[Cormorant_Garamond] text-3xl font-light leading-tight">{s.title}</div>
            </div>
            <div className="md:col-span-6">
              <div className="font-[Outfit] text-base leading-relaxed text-[#0A0A0A]/75">{s.body}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Process;
